"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateYears = void 0;

var tslib_1 = require("tslib");

var generateYears = function generateYears(_a) {
  var currentYear = _a.currentYear,
      period = _a.period;
  return tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(Array.from({
    length: period
  }, function (_, i) {
    return currentYear - (period - i);
  })), false), [currentYear], false), tslib_1.__read(Array.from({
    length: period
  }, function (_, i) {
    return currentYear + i + 1;
  })), false);
};

exports.generateYears = generateYears;